// extracted by mini-css-extract-plugin
module.exports = {"hidden":"guideText_hidden__S9P4W","textEmphasis":"guideText_textEmphasis__aeWJR","guideText":"guideText_guideText__rPD5P","enabled":"guideText_enabled___fqb3"};